<template>
  <div>
    <v-text-field
      label="姓名/部门回车搜索"
      filled rounded single-line dense
      class="pt-2 pb-0 px-2"
      v-model="form.name"
      hide-details="auto"
      @keydown="queryKeyDown()"
    ></v-text-field>
    <v-list v-if='items.length > 0'>
      <template v-for="(item, index) in items">
        <v-list-item :key="index">
          <v-list-item-content>
            <v-list-item-title>
              {{item.name}}
              <v-chip label x-small color="primary" class="pa-2">{{item.deptStr}}</v-chip>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-checkbox v-model="selected" multiple :value='returnObject ? item :  item.id'></v-checkbox>
          </v-list-item-action>
        </v-list-item>
      </template>
      <v-card-text>
      <v-row align="center" justify="end" class="mt-1" >
          <v-pagination
            small
            v-model="page.current"
            :length="page.count"
            @input="nextPage"
            :total-visible="4"
          ></v-pagination>
      </v-row>
      </v-card-text>
    </v-list>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        size="30"
      ></v-progress-circular>
    </v-overlay>
 </div>
</template>

<script>
  import { list } from '@/api/system/user.js'

  export default {
    name: 'VUserIdsList',
    components: {
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      returnObject: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          name: '',
          workState: 1,
          accountType: 1
        },
        selected: this.value,
        items: [], // 当前页用户
        userList: [], // 存放所有用户
        page: {
          total: 0,
          count: 0,
          size: 10,
          current: 1,
          orderByField: 'id',
          asc: false
        }
      }
    },
    methods: {
      loadData () {
        Object.assign(this.pageParams, this.form)
        this.items = []
        this.loading = true
        list(this.pageParams).then(res => {
          if (res.status === 200) {
            this.page.count = res.data.pages
            this.page.current = res.data.current
            this.page.total = res.data.total
            const this_ = this
            res.data.records.forEach(item => {
              this_.items.push({ id: item.id, name: item.name, uid: item.userId, deptStr: item.deptStr })
            })
            this.selected = JSON.parse(JSON.stringify(this.selected))
            this.buildAllUser(this.items)
          }
          this.loading = false
        })
      },
      buildAllUser (arr) {
        arr.forEach(item => {
          this.userList.pushUniqueObj(
            {
              key: item.id,
              id: item.id,
              name: item.name,
              uid: item.userId
            }
          )
        })
      },
      nextPage (current) {
        this.page.current = current
        this.loadData()
      },
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.page.current = 1
          this.loadData()
        }
      },
    },
    watch: {
      value (obj) {
        this.selected = obj
        this.buildAllUser(obj)
      },
      selected (obj) {
        this.$emit('input', obj)
        this.$emit('on-change', obj)
      }
    },
    computed: {
      pageParams () {
        return {
          page: {
            current: this.page.current,
            size: this.page.size,
            asc: this.page.asc
          }
        }
      }
    },
    mounted() {
      this.loadData()
    }
  }
</script>

<style >
  .v-input__append-outer{
    margin-top: -3px !important;
  }
  .chip-dom {
    border: 1px solid #e0e0e0;
    height: 80px;
    padding: 5px;
    margin: 5px 7px 0 7px;
    border-radius: 3px;
    overflow: auto;
  }
</style>
